import {
  ADMIN_LIST,
  ADMIN_REPORT,
  AGENT_LIST,
  ALAMAHA,
  AQUA_CALENDAR,
  BLOCK_SLOT,
  CHECKOUT,
  ENABLE_SLOT,
  SOURCE,
  USER,
} from "./constants";
import { http } from "./httpServices";

export function getAquaSlotDetails(date: string) {
  return http.get(`${CHECKOUT}${AQUA_CALENDAR}`, { params: { date } });
}

export function getAgentList() {
  return http.get(`${USER}${AGENT_LIST}`);
}

export function getReport(
  agentId: string,
  date: string,
  filter: string,
  searchText: string,
  page: any
) {
  return http.get(`${ALAMAHA}${SOURCE}${ADMIN_LIST}`, {
    params: {
      agentId,
      date,
      filter,
      searchText,
      page,
      limit: 100,
    },
  });
}

export function downloadReport(
  agentId: string,
  date: string,
  filter: string,
  searchText: string
) {
  return http.get(`${ALAMAHA}${SOURCE}${ADMIN_REPORT}`, {
    responseType: "blob",
    params: {
      agentId,
      date,
      filter,
      searchText,
    },
  });
}

export function blockSlot(data: any) {
  return http.post(`${CHECKOUT}${BLOCK_SLOT}`, data);
}

export function enableSlot(data: any) {
  return http.post(`${CHECKOUT}${ENABLE_SLOT}`, data);
}
